import { f as BarGaugeValueMode, e as BarGaugeSizing, g as BarGaugeNamePlacement, h as BarGaugeDisplayMode } from '../../../../../index-B0HfjrH_.js';

"use strict";
const pluginVersion = "12.2.1";
const defaultOptions = {
  displayMode: BarGaugeDisplayMode.Gradient,
  maxVizHeight: 300,
  minVizHeight: 16,
  minVizWidth: 8,
  namePlacement: BarGaugeNamePlacement.Auto,
  showUnfilled: true,
  sizing: BarGaugeSizing.Auto,
  valueMode: BarGaugeValueMode.Color
};

export { defaultOptions, pluginVersion };
